import { curry } from 'lib/util'
import count from 'app/_shared/events/search/count'
import searchWith from 'app/_shared/events/search/with'

/**
 * Count With Event Handler
 *
 * @type {Gaia.AppModule.EventHandler}
 * @returns {Promise<{total: {count: *}}>}
 */
const countWith = async (filters, module, component, event) => {
  const additionalParameters = await searchWith(filters, module, component, event)
  const result = await count(null, module, component, additionalParameters)

  return { total: { count: result.total.count } }
}

export const countWithFilter = curry((module, component, event) => countWith(['filter'], module, component, event))
export const countWithFilterAndQuery = curry((module, component, event) => countWith(['filter', 'query'], module, component, event))
export const countWithQuery = curry((module, component, event) => countWith(['query'], module, component, event))
